import React from 'react'
import { ColumnProps } from 'antd/lib/table'

import { Table } from 'src/components/Ant'

import { WrapTableDiv } from '../../styles'

export interface R7HeaderTableGeneric {
  name: string
  percent: string
  total: number
}

interface R7HeaderTableProps {
  columns: ColumnProps<R7HeaderTableGeneric>[]
  dataSource: R7HeaderTableGeneric[]
}

function R7HeaderTable({ columns, dataSource }: R7HeaderTableProps) {
  return (
    <WrapTableDiv>
      <Table
        className="table-sm"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </WrapTableDiv>
  )
}

export default R7HeaderTable
